export type SimpleGrade =
  | {pointsEarned: number; pointsAvailable: number}
  | {pointsReceived: number; pointsAvailable: number}
  | {exactNumerator: number; exactDenominator: number; pointsAvailable?: number}
  | null
  | undefined;

export function gradeToDecimal(grade: SimpleGrade): number {
  if (!grade) {
    return 0;
  }

  if ('exactNumerator' in grade && 'exactDenominator' in grade) {
    if (!grade.exactDenominator) {
      return 0;
    }
    if (grade.pointsAvailable !== undefined && !grade.pointsAvailable) {
      return 0;
    }

    return grade.exactNumerator / grade.exactDenominator;
  }

  if ('pointsAvailable' in grade) {
    if (!grade.pointsAvailable) {
      return 0;
    }

    const earned = 'pointsEarned' in grade ? grade.pointsEarned : grade.pointsReceived;
    return earned / grade.pointsAvailable;
  }

  return 0;
}

export function scaleGradeToPoints(grade: SimpleGrade, points: number) {
  return gradeToDecimal(grade) * points;
}
